import { store } from '@betacrew/jars-flux'
import { ENDPOINT_RESULT_TYPE, PAGE_STATE } from '../../constants/constants'; 
export const componentKey = "FORGOT_PASSWORD";

const initialForgotPasswordFormFields = {
    email: "",
    GRecaptchaResponse: "",
};
const initialEndpointResult =  {
    showMessage: false,
    message: "",
    resulType: ENDPOINT_RESULT_TYPE.ERROR,
};

const initialResetPasswordFormFields = {
    email: "",
    token: "",
    password: "",
    confirmPassword: "",
    GRecaptchaResponse: "",
};

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setForgotPasswordFormFields: (state, action) => {
            state.forgotPasswordFormFields = {
                ...state.forgotPasswordFormFields,
                ...action.payload,
            }
        },
        setResetPasswordFormFields: (state, action) => {
            state.resetPasswordFormFields = {
                ...state.resetPasswordFormFields,
                ...action.payload,
            }
        },
        setEndpointResult: (state, action) => {
            state.endpointResult = {
                ...state.endpointResult,
                ...action.payload,
            };
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        resetForms: (state, action) => {
            state.forgotPasswordFormFields = initialForgotPasswordFormFields;
            state.resetPasswordFormFields = initialResetPasswordFormFields;
        },
        setValidResetToken: (state, action) => {
            state.validResetToken = action.payload;
        },
        resetEverythingOnScreen: (state, action) => {
            state.forgotPasswordFormFields = initialForgotPasswordFormFields;
            state.resetPasswordFormFields = initialResetPasswordFormFields;
            state.endpointResult = initialEndpointResult;
        }
    }, 
    initialReducerState: {
        forgotPasswordFormFields: initialForgotPasswordFormFields,
        endpointResult: initialEndpointResult,
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        resetPasswordFormFields: initialResetPasswordFormFields,
        validResetToken: false,
    }
});
export const { setForgotPasswordFormFields, setResetPasswordFormFields, setEndpointResult, setLoadingState, resetForms, setValidResetToken, resetEverythingOnScreen } = actions;